import { DropdownMenuCheckboxItem, DropdownMenuRadioItem } from "ui";

import {
  type FilterAction,
  type FilterGroupConfig,
  type FilterOptionConfig,
} from "src/components/filterConfig";

interface ConfigurableFilterOptionProps {
  group: FilterGroupConfig;
  option: FilterOptionConfig;
  selected: boolean;
  onAction: (action: FilterAction) => void;
}

export function ConfigurableFilterOption(props: ConfigurableFilterOptionProps) {
  function toggle() {
    props.onAction({
      type: props.selected ? "filter-deselected" : "filter-selected",
      filter: props.group.filter,
      value: props.option.value,
    });
  }

  if (props.group.selection === "single") {
    return (
      <DropdownMenuRadioItem value={props.option.value}>
        {props.option.label}
      </DropdownMenuRadioItem>
    );
  }

  return (
    <DropdownMenuCheckboxItem
      checked={props.selected}
      className="gap-2"
      onCheckedChange={toggle}
      onSelect={(event) => {
        event.preventDefault();
      }}
    >
      {props.option.color ? (
        <span
          className="size-2.5 shrink-0 rounded-full"
          style={{ backgroundColor: props.option.color }}
        />
      ) : null}
      <span>{props.option.label}</span>
    </DropdownMenuCheckboxItem>
  );
}
